import { Core4MetricAverage } from '../../../model/Entities';
import {
    lacrosseCore4Age1012,
    lacrosseCore4Age1314,
    lacrosseCore4Age1516,
    lacrosseCore4Age1718,
    lacrosseCore4AgeCollege,
    lacrosseCore4AgePro,
} from './PlayerCore4LacrosseAges';
import {
    lacrosseCore4Metric10YD,
    lacrosseCore4Metric40YD,
    lacrosseCore4Metric5105,
    lacrosseCore4MetricBroadJump,
    lacrosseCore4MetricHandGripLT,
    lacrosseCore4MetricHandGripRT,
    lacrosseCore4MetricShotVeloL,
    lacrosseCore4MetricShotVeloR,
    lacrosseCore4MetricTDrill,
    lacrosseCore4MetricVerticalJump,
    lacrosseCore4MetricWallBallTestL,
    lacrosseCore4MetricWallBallTestR,
} from './PlayerCore4LacrosseMetrics';

export const lacrosseCore4Averages: Core4MetricAverage[] = [
    /************************************ MALE ************************************/

    // ACCURACY
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 48 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 48 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 10 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 10 },

    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 66 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 66 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 15 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 15 },

    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 75 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 75 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 18 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 18 },

    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 85 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 85 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 20 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 20 },

    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 92 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 92 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 24 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 24 },

    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricShotVeloR, gender: 'Male', average: 100 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricShotVeloL, gender: 'Male', average: 100 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricWallBallTestR, gender: 'Male', average: 26 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricWallBallTestL, gender: 'Male', average: 26 },

    // SPEED

    { age: lacrosseCore4Age1012, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 2 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 6 },

    { age: lacrosseCore4Age1314, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 1.9 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 5.6 },

    { age: lacrosseCore4Age1516, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 1.8 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 5.2 },

    { age: lacrosseCore4Age1718, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 1.75 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 5 },

    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 1.7 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 4.8 },

    { age: lacrosseCore4AgePro, metric: lacrosseCore4Metric10YD, gender: 'Male', average: 1.65 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4Metric40YD, gender: 'Male', average: 4.6 },

    // AGILITY

    { age: lacrosseCore4Age1012, metric: lacrosseCore4Metric5105, gender: 'Male', average: 5.5 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricTDrill, gender: 'Male', average: 12.5 },

    { age: lacrosseCore4Age1314, metric: lacrosseCore4Metric5105, gender: 'Male', average: 5.2 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricTDrill, gender: 'Male', average: 11.3 },

    { age: lacrosseCore4Age1516, metric: lacrosseCore4Metric5105, gender: 'Male', average: 4.9 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricTDrill, gender: 'Male', average: 10.7 },

    { age: lacrosseCore4Age1718, metric: lacrosseCore4Metric5105, gender: 'Male', average: 4.7 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricTDrill, gender: 'Male', average: 10.4 },

    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4Metric5105, gender: 'Male', average: 4.5 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricTDrill, gender: 'Male', average: 9.9 },

    { age: lacrosseCore4AgePro, metric: lacrosseCore4Metric5105, gender: 'Male', average: 4.4 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricTDrill, gender: 'Male', average: 9.5 },

    // STRENGTH

    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 16 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 50 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 50 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricBroadJump, gender: 'Male', average: 64 },

    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 18 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 65 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 65 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricBroadJump, gender: 'Male', average: 80 },

    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 20 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 85 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 85 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricBroadJump, gender: 'Male', average: 92 },

    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 22 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 95 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 95 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricBroadJump, gender: 'Male', average: 100 },

    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 28 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 105 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 105 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricBroadJump, gender: 'Male', average: 105 },

    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricVerticalJump, gender: 'Male', average: 30 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricHandGripRT, gender: 'Male', average: 125 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricHandGripLT, gender: 'Male', average: 125 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricBroadJump, gender: 'Male', average: 114 },

    /************************************ FEMALE ************************************/

    // ACCURACY
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricShotVeloR, gender: 'Female', average: 44 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricShotVeloL, gender: 'Female', average: 44 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricWallBallTestR, gender: 'Female', average: 10 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricWallBallTestL, gender: 'Female', average: 10 },

    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricShotVeloR, gender: 'Female', average: 55 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricShotVeloL, gender: 'Female', average: 55 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricWallBallTestR, gender: 'Female', average: 15 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricWallBallTestL, gender: 'Female', average: 15 },

    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricShotVeloR, gender: 'Female', average: 67 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricShotVeloL, gender: 'Female', average: 67 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricWallBallTestR, gender: 'Female', average: 18 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricWallBallTestL, gender: 'Female', average: 18 },

    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricShotVeloR, gender: 'Female', average: 75 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricShotVeloL, gender: 'Female', average: 75 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricWallBallTestR, gender: 'Female', average: 20 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricWallBallTestL, gender: 'Female', average: 20 },

    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricShotVeloR, gender: 'Female', average: 80 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricShotVeloL, gender: 'Female', average: 80 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricWallBallTestR, gender: 'Female', average: 24 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricWallBallTestL, gender: 'Female', average: 24 },

    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricShotVeloR, gender: 'Female', average: 90 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricShotVeloL, gender: 'Female', average: 90 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricWallBallTestR, gender: 'Female', average: 26 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricWallBallTestL, gender: 'Female', average: 26 },

    // SPEED
    { age: lacrosseCore4Age1012, metric: lacrosseCore4Metric10YD, gender: 'Female', average: 2.2 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4Metric40YD, gender: 'Female', average: 6 },

    { age: lacrosseCore4Age1314, metric: lacrosseCore4Metric10YD, gender: 'Female', average: 2.1 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4Metric40YD, gender: 'Female', average: 5.6 },

    { age: lacrosseCore4Age1516, metric: lacrosseCore4Metric10YD, gender: 'Female', average: 1.95 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4Metric40YD, gender: 'Female', average: 5.2 },

    { age: lacrosseCore4Age1718, metric: lacrosseCore4Metric10YD, gender: 'Female', average: 1.85 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4Metric40YD, gender: 'Female', average: 5 },

    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4Metric10YD, gender: 'Female', average: 1.75 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4Metric40YD, gender: 'Female', average: 4.8 },

    { age: lacrosseCore4AgePro, metric: lacrosseCore4Metric10YD, gender: 'Female', average: 1.7 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4Metric40YD, gender: 'Female', average: 4.6 },

    // AGILITY
    { age: lacrosseCore4Age1012, metric: lacrosseCore4Metric5105, gender: 'Female', average: 6.3 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricTDrill, gender: 'Female', average: 13 },

    { age: lacrosseCore4Age1314, metric: lacrosseCore4Metric5105, gender: 'Female', average: 5.6 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricTDrill, gender: 'Female', average: 11.7 },

    { age: lacrosseCore4Age1516, metric: lacrosseCore4Metric5105, gender: 'Female', average: 5.2 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricTDrill, gender: 'Female', average: 11 },

    { age: lacrosseCore4Age1718, metric: lacrosseCore4Metric5105, gender: 'Female', average: 4.9 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricTDrill, gender: 'Female', average: 10.5 },

    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4Metric5105, gender: 'Female', average: 4.7 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricTDrill, gender: 'Female', average: 10.1 },

    { age: lacrosseCore4AgePro, metric: lacrosseCore4Metric5105, gender: 'Female', average: 4.5 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricTDrill, gender: 'Female', average: 9.2 },

    // STRENGTH
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricVerticalJump, gender: 'Female', average: 13 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricHandGripRT, gender: 'Female', average: 48 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricHandGripLT, gender: 'Female', average: 48 },
    { age: lacrosseCore4Age1012, metric: lacrosseCore4MetricBroadJump, gender: 'Female', average: 57 },

    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricVerticalJump, gender: 'Female', average: 17 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricHandGripRT, gender: 'Female', average: 60 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricHandGripLT, gender: 'Female', average: 60 },
    { age: lacrosseCore4Age1314, metric: lacrosseCore4MetricBroadJump, gender: 'Female', average: 69 },

    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricVerticalJump, gender: 'Female', average: 19 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricHandGripRT, gender: 'Female', average: 68 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricHandGripLT, gender: 'Female', average: 68 },
    { age: lacrosseCore4Age1516, metric: lacrosseCore4MetricBroadJump, gender: 'Female', average: 80 },

    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricVerticalJump, gender: 'Female', average: 21 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricHandGripRT, gender: 'Female', average: 80 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricHandGripLT, gender: 'Female', average: 80 },
    { age: lacrosseCore4Age1718, metric: lacrosseCore4MetricBroadJump, gender: 'Female', average: 88 },

    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricVerticalJump, gender: 'Female', average: 23 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricHandGripRT, gender: 'Female', average: 97 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricHandGripLT, gender: 'Female', average: 97 },
    { age: lacrosseCore4AgeCollege, metric: lacrosseCore4MetricBroadJump, gender: 'Female', average: 92 },

    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricVerticalJump, gender: 'Female', average: 27 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricHandGripRT, gender: 'Female', average: 116 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricHandGripLT, gender: 'Female', average: 116 },
    { age: lacrosseCore4AgePro, metric: lacrosseCore4MetricBroadJump, gender: 'Female', average: 101 },
];
